var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConstructionLoan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3710 3710",
    style: {
      enableBackground: "new 0 0 3710 3710"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 3710,
    height: 3710
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 2354.5222,
    y1: 2114.5444,
    x2: 2540.082,
    y2: 2794.0947,
    gradientTransform: "matrix(-1 0 0 1 3206 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#E38DDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9571F6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M856.612,2178.056c0,0,6.785-16.75,5.69-24.291c-1.094-7.541-19.045-17.604-31.28-27.996 c-12.235-10.392,0.459,10.451,3.304,15.193c2.845,4.742,12.827,11.854,11.392,27.977L856.612,2178.056z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018923862489376418740000003249901907634930858_",
    gradientUnits: "userSpaceOnUse",
    x1: 2343.3145,
    y1: 2117.605,
    x2: 2528.874,
    y2: 2797.1545,
    gradientTransform: "matrix(-1 0 0 1 3206 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#E38DDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9571F6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018923862489376418740000003249901907634930858_)"
    },
    d: "M834.455,2156.721 c0,0,15.082,112.295-103.243,191.469l125.908,30.034c0,0,40.299-75.353,11.123-200.168L834.455,2156.721z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4F7FA"
    },
    d: "M1648.051,455.247c-370.134,6.538-942.803,147.269-1107.64,508.924 c-57.571,126.312-53.673,312.006-45.879,683.393c2.291,109.16,6.09,268.264,32.77,465.675 c55.423,410.086,93.153,689.258,235.947,851.815c357.799,407.319,1650.255,395.548,2202.171-337.758 c301.073-400.024,347.39-969.071,72.095-1439.359C2734.422,670.158,2143.573,446.494,1648.051,455.247z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AABBCC"
    },
    points: "2962.366,3104.124 2715.093,3104.124 2747.363,1446.567 2962.366,1355.059  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1996.647,
    y: 2585.434,
    style: {
      fill: "#E6EBF4"
    },
    width: 941.831,
    height: 416.317
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1798.726,
    y: 2524.01,
    style: {
      fill: "#AABBCC"
    },
    width: 1201.176,
    height: 78.486
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1798.726,
    y: 2134.993,
    style: {
      fill: "#AABBCC"
    },
    width: 1201.176,
    height: 88.723
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1798.726,
    y: 1749.388,
    style: {
      fill: "#AABBCC"
    },
    width: 1201.176,
    height: 81.898
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEDF3"
    },
    points: "1955.698,1355.068 1955.698,3104.124 1689.528,3104.124 1689.528,1409.447  1792.957,1388.41  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1955.698,
    y: 1360.37,
    style: {
      fill: "#D8DEE8"
    },
    width: 64.836,
    height: 1743.753
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2211.631,
    y: 1360.37,
    style: {
      fill: "#D8DEE8"
    },
    width: 64.836,
    height: 1743.753
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AABBCC"
    },
    points: "2211.631,3104.124 2150.207,3104.124 2150.207,1371.374 2211.631,1355.059  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2467.563,
    y: 1360.37,
    style: {
      fill: "#D8DEE8"
    },
    width: 58.011,
    height: 1743.753
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AABBCC"
    },
    points: "2467.563,3104.124 2402.727,3104.124 2402.727,1376.812 2467.563,1355.059  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2716.671,
    y: 1370.608,
    style: {
      fill: "#D8DEE8"
    },
    width: 58.011,
    height: 1702.804
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AABBCC"
    },
    points: "2716.671,3073.412 2648.422,3073.412 2648.422,1388.186 2716.671,1368.349  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1955.698,
    y: 2991.513,
    style: {
      fill: "#D8DEE8"
    },
    width: 1071.504,
    height: 112.61
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DEE8"
    },
    d: "M1831.038,3104.124h-141.509V1409.447l102.347-21.037 c36.216,54.01,64.638,146.997,51.596,307.073c-30.542,375.046-170.199,321.869-30.202,865.281 C1886.07,2843.338,1866.701,3015.4,1831.038,3104.124z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2962.366,
    y: 1360.37,
    style: {
      fill: "#D8DEE8"
    },
    width: 64.836,
    height: 1743.753
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AABBCC"
    },
    points: "1894.274,3104.124 1649.081,3104.124 1680.311,1446.567 1894.274,1355.059  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 928.556,
    y: 2585.434,
    style: {
      fill: "#E6EBF4"
    },
    width: 938.419,
    height: 416.317
  }), /*#__PURE__*/React.createElement("rect", {
    x: 734.047,
    y: 2524.01,
    style: {
      fill: "#AABBCC"
    },
    width: 1197.764,
    height: 78.486
  }), /*#__PURE__*/React.createElement("rect", {
    x: 734.047,
    y: 2134.993,
    style: {
      fill: "#AABBCC"
    },
    width: 1197.764,
    height: 88.723
  }), /*#__PURE__*/React.createElement("rect", {
    x: 734.047,
    y: 1749.388,
    style: {
      fill: "#AABBCC"
    },
    width: 1197.764,
    height: 81.898
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEDF3"
    },
    points: "891.019,1355.068 891.019,3104.124 624.849,3104.124 624.849,1409.447 728.278,1388.41  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 891.019,
    y: 1360.37,
    style: {
      fill: "#D8DEE8"
    },
    width: 58.011,
    height: 1743.753
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1146.952,
    y: 1360.37,
    style: {
      fill: "#D8DEE8"
    },
    width: 68.249,
    height: 1743.753
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AABBCC"
    },
    points: "1146.952,3104.124 1085.528,3104.124 1085.528,1371.374 1146.952,1355.059  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1399.472,
    y: 1360.37,
    style: {
      fill: "#D8DEE8"
    },
    width: 58.011,
    height: 1743.753
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AABBCC"
    },
    points: "1399.472,3104.124 1334.635,3104.124 1334.635,1376.812 1399.472,1355.059  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1651.992,
    y: 1370.608,
    style: {
      fill: "#D8DEE8"
    },
    width: 61.424,
    height: 1702.804
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AABBCC"
    },
    points: "1651.992,3073.412 1583.743,3073.412 1583.743,1388.186 1651.992,1368.349  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 891.019,
    y: 2991.513,
    style: {
      fill: "#D8DEE8"
    },
    width: 1071.504,
    height: 112.61
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DEE8"
    },
    d: "M765.026,3104.124H624.849V1409.447l101.681-21.037c36.215,54.01,64.305,146.997,51.263,307.073 c-30.542,375.046-170.366,321.869-30.368,865.281C820.224,2843.338,800.689,3015.4,765.026,3104.124z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1894.274,
    y: 1360.37,
    style: {
      fill: "#D8DEE8"
    },
    width: 68.249,
    height: 1743.753
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029033018213149771600000018234480180448226980_",
    gradientUnits: "userSpaceOnUse",
    x1: 2334.4783,
    y1: 970.6563,
    x2: 2351.5403,
    y2: 970.6563
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029033018213149771600000018234480180448226980_)"
    },
    d: "M2343.009,1245.338 c-5.107,0-8.531-4.14-8.531-9.249V705.224c0-5.108,3.424-9.248,8.531-9.248s8.531,4.14,8.531,9.248v530.865 C2351.54,1241.197,2348.117,1245.338,2343.009,1245.338z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065033792268116071760000006624984948299793323_",
    gradientUnits: "userSpaceOnUse",
    x1: 2209.0703,
    y1: 1530.192,
    x2: 2443.4084,
    y2: 1530.192
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000065033792268116071760000006624984948299793323_)"
    },
    points: "2431.035,1636.951  2209.07,1437.183 2221.444,1423.433 2443.408,1623.201  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026134120866740288080000007052667455647073446_",
    gradientUnits: "userSpaceOnUse",
    x1: -93.4085,
    y1: 1530.192,
    x2: 140.9296,
    y2: 1530.192,
    gradientTransform: "matrix(-1 0 0 1 2350 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000026134120866740288080000007052667455647073446_)"
    },
    points: "2221.444,1636.951  2209.07,1623.201 2431.035,1423.433 2443.408,1437.183  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034077124253478028880000005528854420347356314_",
    gradientUnits: "userSpaceOnUse",
    x1: 2209.0703,
    y1: 1735.5093,
    x2: 2443.4084,
    y2: 1735.5093
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000034077124253478028880000005528854420347356314_)"
    },
    points: "2431.035,1842.268  2209.07,1642.5 2221.444,1628.75 2443.408,1828.518  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096050241790156821790000002318195609455540097_",
    gradientUnits: "userSpaceOnUse",
    x1: -93.4085,
    y1: 1735.5093,
    x2: 140.9296,
    y2: 1735.5093,
    gradientTransform: "matrix(-1 0 0 1 2350 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000096050241790156821790000002318195609455540097_)"
    },
    points: "2221.444,1842.268  2209.07,1828.518 2431.035,1628.75 2443.408,1642.5  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181780238114424866150000005244932358069187216_",
    gradientUnits: "userSpaceOnUse",
    x1: 2214.6194,
    y1: 1938.9768,
    x2: 2448.9575,
    y2: 1938.9768
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000181780238114424866150000005244932358069187216_)"
    },
    points: "2436.584,2045.736  2214.619,1845.968 2226.993,1832.218 2448.958,2031.986  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000153681153296266446730000008177922795402468486_",
    gradientUnits: "userSpaceOnUse",
    x1: -98.9576,
    y1: 1938.9768,
    x2: 135.3805,
    y2: 1938.9768,
    gradientTransform: "matrix(-1 0 0 1 2350 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000153681153296266446730000008177922795402468486_)"
    },
    points: "2226.993,2045.736  2214.619,2031.986 2436.584,1832.218 2448.958,1845.968  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000087407771026345908930000003097162857028938406_",
    gradientUnits: "userSpaceOnUse",
    x1: 2214.6194,
    y1: 2151.6929,
    x2: 2448.9575,
    y2: 2151.6929
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000087407771026345908930000003097162857028938406_)"
    },
    points: "2436.584,2258.452  2214.619,2058.684 2226.993,2044.934 2448.958,2244.702  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145052114085787204940000012523302214943709068_",
    gradientUnits: "userSpaceOnUse",
    x1: -98.9576,
    y1: 2151.6929,
    x2: 135.3805,
    y2: 2151.6929,
    gradientTransform: "matrix(-1 0 0 1 2350 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000145052114085787204940000012523302214943709068_)"
    },
    points: "2226.993,2258.452  2214.619,2244.702 2436.584,2044.934 2448.958,2058.684  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000104707855361011494490000013153137068768337553_",
    gradientUnits: "userSpaceOnUse",
    x1: 2214.6194,
    y1: 2366.2585,
    x2: 2448.9575,
    y2: 2366.2585
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000104707855361011494490000013153137068768337553_)"
    },
    points: "2436.584,2473.018  2214.619,2273.25 2226.993,2259.5 2448.958,2459.268  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047781264325957296020000015522297078625666711_",
    gradientUnits: "userSpaceOnUse",
    x1: -98.9576,
    y1: 2366.2585,
    x2: 135.3805,
    y2: 2366.2585,
    gradientTransform: "matrix(-1 0 0 1 2350 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000047781264325957296020000015522297078625666711_)"
    },
    points: "2226.993,2473.018  2214.619,2459.268 2436.584,2259.5 2448.958,2273.25  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163778860356645295340000001195767912990249915_",
    gradientUnits: "userSpaceOnUse",
    x1: 2214.6194,
    y1: 2571.5759,
    x2: 2448.9575,
    y2: 2571.5759
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000163778860356645295340000001195767912990249915_)"
    },
    points: "2436.584,2678.335  2214.619,2478.567 2226.993,2464.817 2448.958,2664.585  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000126307691723724490540000003730409776026155404_",
    gradientUnits: "userSpaceOnUse",
    x1: -98.9576,
    y1: 2571.5759,
    x2: 135.3805,
    y2: 2571.5759,
    gradientTransform: "matrix(-1 0 0 1 2350 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000126307691723724490540000003730409776026155404_)"
    },
    points: "2226.993,2678.335  2214.619,2664.585 2436.584,2464.817 2448.958,2478.567  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000157994211260479116020000005747295161683882390_",
    gradientUnits: "userSpaceOnUse",
    x1: 2215.043,
    y1: 1629.9528,
    x2: 2450.501,
    y2: 1629.9528
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2215.043,
    y: 1619.715,
    style: {
      fill: "url(#SVGID_00000157994211260479116020000005747295161683882390_)"
    },
    width: 235.458,
    height: 20.475
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183222377699891111800000015504062078582429606_",
    gradientUnits: "userSpaceOnUse",
    x1: 2215.043,
    y1: 1838.111,
    x2: 2450.501,
    y2: 1838.111
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2215.043,
    y: 1827.874,
    style: {
      fill: "url(#SVGID_00000183222377699891111800000015504062078582429606_)"
    },
    width: 235.458,
    height: 20.475
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000081621670014925988010000010954723473070466982_",
    gradientUnits: "userSpaceOnUse",
    x1: 2215.043,
    y1: 2051.3882,
    x2: 2450.501,
    y2: 2051.3882
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2215.043,
    y: 2039.445,
    style: {
      fill: "url(#SVGID_00000081621670014925988010000010954723473070466982_)"
    },
    width: 235.458,
    height: 23.887
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000071527662323487402890000014957072257217925810_",
    gradientUnits: "userSpaceOnUse",
    x1: 2215.043,
    y1: 2051.3879,
    x2: 2450.501,
    y2: 2051.3879
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2215.043,
    y: 2046.269,
    style: {
      fill: "url(#SVGID_00000071527662323487402890000014957072257217925810_)"
    },
    width: 235.458,
    height: 10.237
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000149348692415950030850000010737624051788657580_",
    gradientUnits: "userSpaceOnUse",
    x1: 2215.043,
    y1: 2259.5464,
    x2: 2450.501,
    y2: 2259.5464
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2215.043,
    y: 2251.015,
    style: {
      fill: "url(#SVGID_00000149348692415950030850000010737624051788657580_)"
    },
    width: 235.458,
    height: 17.062
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000066480713419712706120000007115393875661120923_",
    gradientUnits: "userSpaceOnUse",
    x1: 2215.043,
    y1: 2465.9985,
    x2: 2450.501,
    y2: 2465.9985
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2215.043,
    y: 2455.761,
    style: {
      fill: "url(#SVGID_00000066480713419712706120000007115393875661120923_)"
    },
    width: 235.458,
    height: 20.475
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031888838697207598030000011018057195100836019_",
    gradientUnits: "userSpaceOnUse",
    x1: 2214.6194,
    y1: 2779.5122,
    x2: 2448.9575,
    y2: 2779.5122
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000031888838697207598030000011018057195100836019_)"
    },
    points: "2436.584,2886.271  2214.619,2686.503 2226.993,2672.753 2448.958,2872.521  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134222453377423549610000002284325397280841887_",
    gradientUnits: "userSpaceOnUse",
    x1: -98.9576,
    y1: 2779.5122,
    x2: 135.3805,
    y2: 2779.5122,
    gradientTransform: "matrix(-1 0 0 1 2350 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000134222453377423549610000002284325397280841887_)"
    },
    points: "2226.993,2886.271  2214.619,2872.521 2436.584,2672.753 2448.958,2686.503  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124871223952053786090000008288874934091574439_",
    gradientUnits: "userSpaceOnUse",
    x1: 2215.043,
    y1: 2669.0383,
    x2: 2450.501,
    y2: 2669.0383
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2215.043,
    y: 2660.507,
    style: {
      fill: "url(#SVGID_00000124871223952053786090000008288874934091574439_)"
    },
    width: 235.458,
    height: 17.062
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023273560992389130600000010710175842261067161_",
    gradientUnits: "userSpaceOnUse",
    x1: 2215.043,
    y1: 2882.3154,
    x2: 2450.501,
    y2: 2882.3154
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2215.043,
    y: 2872.078,
    style: {
      fill: "url(#SVGID_00000023273560992389130600000010710175842261067161_)"
    },
    width: 235.458,
    height: 20.475
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000146483892786132058060000001053511130627995273_",
    gradientUnits: "userSpaceOnUse",
    x1: 2214.6194,
    y1: 2988.7927,
    x2: 2448.9575,
    y2: 2988.7927
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000146483892786132058060000001053511130627995273_)"
    },
    points: "2436.584,3095.552  2214.619,2895.784 2226.993,2882.034 2448.958,3081.802  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000175299148527726153670000013920928561779737514_",
    gradientUnits: "userSpaceOnUse",
    x1: -98.9576,
    y1: 2988.7927,
    x2: 135.3805,
    y2: 2988.7927,
    gradientTransform: "matrix(-1 0 0 1 2350 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000175299148527726153670000013920928561779737514_)"
    },
    points: "2226.993,3095.552  2214.619,3081.802 2436.584,2882.034 2448.958,2895.784  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000068637668215403852660000013005557446397442729_",
    gradientUnits: "userSpaceOnUse",
    x1: 2215.043,
    y1: 3090.4739,
    x2: 2450.501,
    y2: 3090.4739
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2215.043,
    y: 3080.237,
    style: {
      fill: "url(#SVGID_00000068637668215403852660000013005557446397442729_)"
    },
    width: 235.458,
    height: 20.475
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000157267037358943112150000016463477549721617340_",
    gradientUnits: "userSpaceOnUse",
    x1: 2209.0703,
    y1: 1530.192,
    x2: 2443.4084,
    y2: 1530.192
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000157267037358943112150000016463477549721617340_)"
    },
    points: "2431.035,1636.951  2209.07,1437.183 2221.444,1423.433 2443.408,1623.201  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003065211540078499850000017143047655031841456_",
    gradientUnits: "userSpaceOnUse",
    x1: 2204.8057,
    y1: 2252.7217,
    x2: 2225.2803,
    y2: 2252.7217
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2204.806,
    y: 1408.145,
    style: {
      fill: "url(#SVGID_00000003065211540078499850000017143047655031841456_)"
    },
    width: 20.475,
    height: 1689.154
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000032642129094621693990000004714400327900585896_",
    gradientUnits: "userSpaceOnUse",
    x1: 2436.8513,
    y1: 2252.7217,
    x2: 2460.7383,
    y2: 2252.7217
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2436.851,
    y: 1408.145,
    style: {
      fill: "url(#SVGID_00000032642129094621693990000004714400327900585896_)"
    },
    width: 23.887,
    height: 1689.154
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047036547004107495350000000704950959505014916_",
    gradientUnits: "userSpaceOnUse",
    x1: 2180.9187,
    y1: 1275.0597,
    x2: 2484.6252,
    y2: 1275.0597
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047036547004107495350000000704950959505014916_)"
    },
    d: "M2484.625,1097.613v336.854 c0,10.969-8.033,18.039-19.002,18.039h-267.302c-10.969,0-17.402-7.07-17.402-18.039v-336.854H2484.625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M2436.851,1273.338c0,12.259-9.938,22.197-22.197,22.197h-167.178 c-12.259,0-22.197-9.938-22.197-22.197v-78.455c0-12.259,9.938-22.196,22.197-22.196h167.178 c12.259,0,22.197,9.938,22.197,22.196V1273.338z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000154392681461620219550000002321120469997690031_",
    gradientUnits: "userSpaceOnUse",
    x1: 2180.9187,
    y1: 1277.524,
    x2: 2484.6252,
    y2: 1277.524
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000154392681461620219550000002321120469997690031_)"
    },
    d: "M2484.625,1421.369 v13.098c0,10.969-8.033,18.039-19.002,18.039h-267.302c-10.969,0-17.402-7.07-17.402-18.039v-331.925l39.209,5.737 c0,0-20.809,73.935,6.976,109.44c5.123,6.566,11.786,11.799,20.627,15.046c41.747,15.263,105.878,22.228,140.194,61.341 c12.375,14.109,21.649,32.439,23.777,56.83C2417.295,1414.188,2453.913,1410.507,2484.625,1421.369z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091016716487145757660000015934075343473231260_",
    gradientUnits: "userSpaceOnUse",
    x1: 2109.2576,
    y1: 3109.2422,
    x2: 2559.6987,
    y2: 3109.2422
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000091016716487145757660000015934075343473231260_)"
    },
    d: "M2547.4,3076.824h-428.184 c-6.309,0-9.958,4.89-9.958,11.2v53.636h450.441v-53.636C2559.699,3081.715,2553.709,3076.824,2547.4,3076.824z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008848364171493499620000013020931984962398111_",
    gradientUnits: "userSpaceOnUse",
    x1: 2415.8464,
    y1: 3039.4641,
    x2: 2248.8413,
    y2: 3318.2065
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008848364171493499620000013020931984962398111_)"
    },
    d: "M2587.091,3141.66h-507.567 c-6.309,0-11.216,5.003-11.216,11.313v53.524h528.927v-53.524C2597.236,3146.664,2593.4,3141.66,2587.091,3141.66z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062901713887505177630000001883299874094411923_",
    gradientUnits: "userSpaceOnUse",
    x1: 2073.5315,
    y1: 1527.5797,
    x2: 2171.4177,
    y2: 1527.5797,
    gradientTransform: "matrix(-1 0 0 1 3343.2922 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062901713887505177630000001883299874094411923_)"
    },
    d: "M1225.253,1608.803 c0.614,0,1.215,0.675,1.802,0.675h1.543c9.312,0,18.784-5.743,26.674-14.939c11.005-12.829,16.336-30.923,13.912-46.678 c-0.777-5.047-5.502-8.69-10.547-7.903c-5.049,0.777-8.511,5.414-7.735,10.462c1.601,10.41-2.194,22.415-9.669,31.127 c-4.131,4.816-8.972,7.455-12.635,7.455h-1.584c-9.855,0-23.336,0.363-30.533-6.818c-4.054-4.046-6.11-10.412-6.11-19.231 c0-30.112,40.228-46.013,40.635-46.17c3.502-1.36,5.85-4.672,5.914-8.429l0.925-53.455c0.089-5.107-3.98-9.219-9.087-9.219 c-0.055,0-0.109,0-0.164,0c-5.033,0-9.156,3.867-9.243,8.922l-0.824,47.669c-13.729,6.666-46.653,26.222-46.653,60.881 c0,13.909,3.884,25.156,11.543,32.796C1195.445,1607.95,1212.947,1608.803,1225.253,1608.803z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088851736292892214020000002845445275810606216_",
    gradientUnits: "userSpaceOnUse",
    x1: 1245.9122,
    y1: 1200.7196,
    x2: 1262.9742,
    y2: 1200.7196
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088851736292892214020000002845445275810606216_)"
    },
    d: "M1262.974,1128.803v153.081h-17.062 v-153.081c0-5.117,3.414-9.249,8.531-9.249C1259.56,1119.555,1262.974,1123.687,1262.974,1128.803z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000073700364022776448680000015183710825250593932_",
    gradientUnits: "userSpaceOnUse",
    x1: 2185.7239,
    y1: 903.6047,
    x2: 2482.0212,
    y2: 903.6047
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000073700364022776448680000015183710825250593932_)"
    },
    d: "M2194.974,1126.033 c-1.053,0-2.125-0.181-3.172-0.564c-4.798-1.752-7.267-7.061-5.515-11.86l155.721-426.361c1.375-3.763,5.063-6.17,9.017-6.069 c4.003,0.143,7.459,2.847,8.561,6.698l122.074,426.361c1.406,4.91-1.434,10.031-6.345,11.436 c-4.912,1.404-10.032-1.434-11.437-6.346l-114.249-399.029l-145.968,399.657 C2202.293,1123.707,2198.749,1126.033,2194.974,1126.033z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067211725049753734720000000023354826673738373_",
    gradientUnits: "userSpaceOnUse",
    x1: 2261.6816,
    y1: 920.7145,
    x2: 2418.5002,
    y2: 920.7145
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000067211725049753734720000000023354826673738373_)"
    },
    d: "M2344.918,959.558 c-2.041,0-4.085-0.674-5.777-2.027l-73.988-59.19c-3.988-3.19-4.635-9.01-1.444-12.999c3.191-3.988,9.01-4.635,12.999-1.445 l67.995,54.395l58.516-50.366c3.873-3.335,9.712-2.896,13.043,0.975c3.332,3.871,2.895,9.711-0.976,13.042l-64.333,55.376 C2349.22,958.808,2347.071,959.558,2344.918,959.558z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000115512980425555939990000012597002252744202424_",
    gradientUnits: "userSpaceOnUse",
    x1: 2222.6577,
    y1: 1038.4753,
    x2: 2457.0378,
    y2: 1038.4753
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000115512980425555939990000012597002252744202424_)"
    },
    d: "M2344.919,1070.54 c-1.179,0-2.354-0.226-3.463-0.672l-113.01-45.632c-4.736-1.913-7.026-7.303-5.113-12.039 c1.912-4.736,7.302-7.021,12.039-5.114l109.96,44.402l99.726-30.8c4.888-1.503,10.059,1.227,11.566,6.107 c1.508,4.881-1.228,10.06-6.107,11.566l-102.868,31.77C2346.758,1070.403,2345.837,1070.54,2344.919,1070.54z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132086531001437649310000010975209025773644727_",
    gradientUnits: "userSpaceOnUse",
    x1: 1194.7257,
    y1: 981.5312,
    x2: 2898.385,
    y2: 981.5312
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132086531001437649310000010975209025773644727_)"
    },
    d: "M2896.539,1095.48 c-3.049,4.1-8.888,4.953-12.988,1.902l-533.469-396.558l-1138.295,422.403v158.657h-17.062v-165.086 c0-3.869,1.328-7.346,4.934-8.691l1148.869-426.339c2.919-1.116,5.932-0.623,8.457,1.246l537.736,399.511 C2898.822,1085.575,2899.556,1091.38,2896.539,1095.48z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000123415888512060404840000004186173129008169352_",
    gradientUnits: "userSpaceOnUse",
    x1: 1146.9517,
    y1: 1114.6753,
    x2: 2952.1284,
    y2: 1114.6753
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000123415888512060404840000004186173129008169352_)"
    },
    d: "M2952.128,1107.26 c0-10.982-8.902-19.884-19.884-19.884H1166.836c-10.982,0-19.884,8.903-19.884,19.884v14.83 c0,10.982,8.903,19.884,19.884,19.884h1765.408c10.982,0,19.884-8.903,19.884-19.884V1107.26z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000190501128210282400000014552590320179471756_",
    gradientUnits: "userSpaceOnUse",
    x1: 2730.3203,
    y1: 1268.2347,
    x2: 2931.6538,
    y2: 1268.2347
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2730.32,
    y: 1141.975,
    style: {
      fill: "url(#SVGID_00000000190501128210282400000014552590320179471756_)"
    },
    width: 201.333,
    height: 252.52
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2747.383,
    y: 1155.625,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 27.299,
    height: 204.746
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2788.332,
    y: 1155.625,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 34.124,
    height: 204.746
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2839.518,
    y: 1155.625,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 30.712,
    height: 204.746
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2887.292,
    y: 1155.625,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 30.712,
    height: 204.746
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000166674608519531646160000015577326221544255649_",
    gradientUnits: "userSpaceOnUse",
    x1: 1177.6478,
    y1: 1370.6084,
    x2: 1280.0365,
    y2: 1370.6084
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000166674608519531646160000015577326221544255649_)"
    },
    d: "M1270.463,1271.647h-85.702 c-5.449,0-7.097,5.476-7.097,10.925v113.942c0,4.33-0.303,8.59,1.76,12.395l31.89,58.638c1.161,2.141,2.709,2.021,5.145,2.021 h24.38c2.48,0,4.754,0.071,5.895-2.132l30.535-58.501c1.916-3.697,2.769-7.072,2.769-11.235v-115.128 C1280.036,1277.123,1275.911,1271.647,1270.463,1271.647z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158723254777167191120000009457285164767619233_",
    gradientUnits: "userSpaceOnUse",
    x1: 1194.7257,
    y1: 1336.4834,
    x2: 1266.3868,
    y2: 1336.4834
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000158723254777167191120000009457285164767619233_)"
    },
    d: "M1266.387,1358.649 c0,12.259-9.938,22.197-22.197,22.197h-27.268c-12.259,0-22.197-9.938-22.197-22.197v-44.33 c0-12.259,9.938-22.197,22.197-22.197h27.268c12.259,0,22.197,9.938,22.197,22.197V1358.649z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010294257774164663500000000299680361279991179_",
    gradientUnits: "userSpaceOnUse",
    x1: 834.457,
    y1: 1759.2521,
    x2: 1556.5931,
    y2: 1759.2521
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000010294257774164663500000000299680361279991179_)"
    },
    d: "M840.211,1937.272 c-1.57,0-3.133-0.638-4.269-1.896c-2.13-2.356-1.946-5.994,0.411-8.125l381.284-344.539c2.205-1.988,5.567-1.972,7.752,0.036 l329.348,303.2c2.338,2.151,2.488,5.791,0.336,8.128c-2.15,2.339-5.79,2.485-8.127,0.337l-325.489-299.647L844.065,1935.79 C842.966,1936.784,841.586,1937.272,840.211,1937.272z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000071547797546325779600000017433093841457360566_",
    gradientUnits: "userSpaceOnUse",
    x1: 1033.557,
    y1: 2219.5774,
    x2: 527.4297,
    y2: 2382.0088
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCB148"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0521,
    style: {
      stopColor: "#FDBA46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1424,
    style: {
      stopColor: "#FFC244"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3183,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4849,
    style: {
      stopColor: "#FDB946"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#F99C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8658,
    style: {
      stopColor: "#F8924F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8924F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000071547797546325779600000017433093841457360566_)"
    },
    d: "M1616.217,2201.212 c0,234.799-183.598,419.503-418.258,412.297c-244.211-7.5-449.6-218.412-449.6-470.806 c0-252.393,205.389-435.612,449.6-410.183C1432.619,1756.954,1616.217,1966.414,1616.217,2201.212z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039093267222949998310000002553293618500634556_",
    gradientUnits: "userSpaceOnUse",
    x1: 1442.9844,
    y1: 1715.7783,
    x2: 991.145,
    y2: 2712.6201
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDB44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEEF06"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039093267222949998310000002553293618500634556_)"
    },
    d: "M1679.627,2180.967 c0,234.799-183.599,419.503-418.258,412.297c-244.211-7.5-449.601-218.412-449.601-470.805 c0-252.394,205.39-435.613,449.601-410.184C1496.028,1736.709,1679.627,1946.168,1679.627,2180.967z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152966084912016712670000001134836553991282568_",
    gradientUnits: "userSpaceOnUse",
    x1: 1359.8684,
    y1: 2768.3342,
    x2: 1272.6851,
    y2: 2292.0547
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCB148"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0521,
    style: {
      stopColor: "#FDBA46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1424,
    style: {
      stopColor: "#FFC244"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3183,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4849,
    style: {
      stopColor: "#FDB946"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#F99C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8658,
    style: {
      stopColor: "#F8924F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8924F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000152966084912016712670000001134836553991282568_)"
    },
    d: "M1661.208,2179.725 c0,224.459-175.67,400.731-399.839,393.473c-232.87-7.541-428.389-208.823-428.389-449.309s195.518-415.406,428.389-391.547 C1485.538,1755.308,1661.208,1955.266,1661.208,2179.725z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111908344931189574900000010197539413543844996_",
    gradientUnits: "userSpaceOnUse",
    x1: 1175.0231,
    y1: 1997.4232,
    x2: 1534.3173,
    y2: 2760.1362
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCB148"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0521,
    style: {
      stopColor: "#FDBA46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1424,
    style: {
      stopColor: "#FFC244"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3183,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4849,
    style: {
      stopColor: "#FDB946"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#F99C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8658,
    style: {
      stopColor: "#F8924F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8924F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111908344931189574900000010197539413543844996_)"
    },
    d: "M1648.017,2178.836 c0,217.054-169.982,387.303-386.648,380.029c-224.783-7.547-413.281-201.953-413.281-433.958 c0-232.005,188.499-400.995,413.281-378.234C1478.034,1768.613,1648.017,1961.782,1648.017,2178.836z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000179608155114469688740000012993437495797320626_",
    gradientUnits: "userSpaceOnUse",
    x1: 1160.7085,
    y1: 1833.2972,
    x2: 1341.3739,
    y2: 2510.3994
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDB44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEEF06"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000179608155114469688740000012993437495797320626_)"
    },
    d: "M1259.15,1820.516L1259.15,1820.516 c11.53,1.096,20.862,11.475,20.862,23.185v39.963c23.054,2.574,46.141,6.582,69.262,12.016 c17.047,4.006,33.979,8.776,50.798,14.305c10.077,3.313,16.944,13.488,15.916,23.982l-4.908,50.112 c-1.302,13.296-14.445,21.103-26.818,15.586c-11.078-4.94-22.437-9.172-34.078-12.695 c-20.314-6.146-41.736-10.153-64.278-12.012l-5.894-0.485v114.449c60.145,16.827,104.317,39.465,132.863,67.939 c28.408,28.337,42.562,63.654,42.562,106.051c0,45.849-15.649,82.563-47.069,110.251 c-31.589,27.836-75.877,43.492-133.149,46.881v44.108c0,11.714-9.339,20.839-20.879,20.38l-0.37-0.015 c-11.563-0.46-20.953-10.362-20.953-22.117v-43.511l-9.294-0.419c-26.849-1.211-52.566-3.95-77.137-8.224 c-18.197-3.166-35.966-7.251-53.305-12.26c-10.486-3.029-17.685-13.018-16.722-23.75l5.775-64.418 c1.248-13.926,15.236-22.03,28.479-16.806c15.435,6.088,31.063,11.217,46.881,15.389 c24.651,6.501,49.636,10.67,74.953,12.522l0.371-127.309c-57.733-14.286-100.957-35.445-129.355-63.472 c-28.531-28.159-42.847-64.196-42.847-108.011c0-45.344,15.523-80.344,46.452-104.908 c30.771-24.44,74.515-36.599,130.949-36.568V1839.8C1238.216,1828.05,1247.597,1819.417,1259.15,1820.516z  M1238.216,1973.288c-17.843,1.298-31.757,6.198-41.716,14.707c-9.975,8.523-14.968,19.979-14.968,34.355 c0,13.62,4.619,25.004,13.847,34.143c9.214,9.124,23.505,16.41,42.837,21.853V1973.288z M1275.218,2203.818v116.747 c19.396,0.038,34.27-4.593,44.653-13.88c10.365-9.272,15.541-22.367,15.541-39.3c0-15.438-4.81-28.242-14.443-38.424 C1311.322,2218.763,1296.086,2210.384,1275.218,2203.818z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129204783335093347110000004893246094045703842_",
    gradientUnits: "userSpaceOnUse",
    x1: 1069.3198,
    y1: 2046.7822,
    x2: 1427.8892,
    y2: 2807.9563
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCB148"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0521,
    style: {
      stopColor: "#FDBA46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1424,
    style: {
      stopColor: "#FFC244"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3183,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4849,
    style: {
      stopColor: "#FDB946"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#F99C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8658,
    style: {
      stopColor: "#F8924F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8924F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000129204783335093347110000004893246094045703842_)"
    },
    d: "M1191.4,2231.989 c13.063-129.023,131.641-183.643,116.167-302.324c-9.538-73.148-64.98-134.794-126.827-182.926 c-187.593,19.674-332.653,175.005-332.653,378.169c0,232.006,188.499,426.411,413.281,433.958 c21.825,0.732,43.14-0.402,63.866-3.119C1235.965,2466.915,1180.177,2342.835,1191.4,2231.989z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129904930429861523110000008749816633553475994_",
    gradientUnits: "userSpaceOnUse",
    x1: 2501.4287,
    y1: 986.4298,
    x2: 3129.2573,
    y2: 986.4298
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#893976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129904930429861523110000008749816633553475994_)"
    },
    d: "M3075.884,1065.133 c26.909,2.266,50.713-19.517,53.168-48.655c2.454-29.137-17.371-54.596-44.281-56.862c-1.395-0.118-2.775-0.131-4.149-0.123 c-1.284-15.049-3.63-29.79-7.007-44.117c1.277-0.523,2.552-1.065,3.809-1.711c24.531-12.607,35.233-44.199,23.904-70.568 c-11.329-26.367-40.4-37.523-64.931-24.917c-1.283,0.66-2.504,1.4-3.71,2.159c-8.009-12.094-16.878-23.484-26.532-34.073 c0.892-1.16,1.77-2.341,2.584-3.6c15.58-24.1,10.313-57.039-11.764-73.572c-22.078-16.531-52.605-10.394-68.185,13.706 c-0.799,1.235-1.505,2.506-2.195,3.784c-12.463-6.015-25.474-10.996-38.947-14.893c0.239-1.468,0.458-2.945,0.585-4.454 c2.455-29.138,7.764-62.034-19.178-63.879c-62.323-4.268-75.817,26.534-78.271,55.671c-0.126,1.51-0.158,3.002-0.168,4.489 c-13.935,1.589-27.595,4.323-40.889,8.168c-0.466-1.375-0.951-2.746-1.531-4.098c-11.329-26.366-9.284-43.956-35.035-34.076 c-56.153,21.543-65.13,53.36-53.801,79.727c0.593,1.378,1.26,2.689,1.946,3.982c-11.289,8.824-21.939,18.57-31.859,29.155 c-1.061-0.951-2.141-1.884-3.296-2.749c-22.076-16.531-52.604-10.396-68.184,13.706c-15.581,24.101-10.313,57.039,11.765,73.571 c1.13,0.847,2.295,1.595,3.469,2.325c-5.727,13.56-10.505,27.701-14.289,42.324c-1.353-0.238-2.717-0.456-4.11-0.573 c-26.91-2.267-50.713,19.517-53.168,48.655c-2.454,29.136,17.371,54.595,44.281,56.862c1.394,0.117,2.775,0.131,4.149,0.122 c1.284,15.05,3.63,29.79,7.007,44.119c-1.277,0.522-2.552,1.064-3.808,1.709c-24.532,12.608-35.233,44.201-23.905,70.568 c11.329,26.368,40.401,37.522,64.933,24.917c1.282-0.658,2.504-1.399,3.709-2.158c8.009,12.095,16.878,23.484,26.532,34.073 c-0.892,1.16-1.77,2.341-2.583,3.601c-15.58,24.1-10.313,57.039,11.763,73.571c22.078,16.532,69.869,8.968,85.449-15.132 c0.798-1.235-15.758-1.078-15.069-2.356c12.462,6.015,25.474,10.996,38.947,14.892c-0.239,1.468-0.458,2.946-0.585,4.455 c-2.455,29.138,17.371,54.596,44.281,56.862c26.91,2.267,50.713-19.517,53.167-48.655c0.127-1.509,0.158-3.002,0.168-4.49 c13.935-1.588,27.596-4.322,40.889-8.167c0.466,1.375,0.951,2.745,1.531,4.097c11.329,26.366,40.4,37.523,64.932,24.916 c24.531-12.606,35.233-44.2,23.904-70.566c-0.593-1.378-1.26-2.69-1.946-3.982c11.291-8.825,21.939-18.571,31.858-29.156 c1.061,0.951,2.142,1.885,3.296,2.748c22.077,16.531,52.604,10.396,68.185-13.705c15.58-24.102,10.313-57.039-11.764-73.572 c-1.131-0.845-2.296-1.594-3.469-2.323c5.726-13.561,10.505-27.701,14.288-42.325 C3073.127,1064.798,3074.49,1065.015,3075.884,1065.133z M2799.21,1181.61c-97.704-8.229-169.684-100.661-160.774-206.453 c8.91-105.793,95.337-184.882,193.04-176.653c97.704,8.228,169.683,100.661,160.774,206.453 C2983.338,1110.748,2896.912,1189.839,2799.21,1181.61z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010989333492365312610000001780726293447646389_",
    gradientUnits: "userSpaceOnUse",
    x1: 2858.009,
    y1: 984.818,
    x2: 3129.2568,
    y2: 984.818
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#893976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000010989333492365312610000001780726293447646389_)"
    },
    d: "M3077.424,913.664 c24.531-12.607,35.232-44.2,23.904-70.568c-11.329-26.367-40.4-37.523-64.932-24.917c-1.282,0.659-2.503,1.4-3.708,2.158 c-8.01-12.095-16.879-23.484-26.533-34.073c0.892-1.159,1.77-2.341,2.584-3.601c15.581-24.099,27.55-71.905,3.894-86.083 c-44.898-26.911-68.262,2.119-83.842,26.219c-0.799,1.235-1.505,2.505-2.196,3.783c-12.462-6.015-25.474-10.994-38.947-14.891 c0.239-1.468,0.458-2.945,0.585-4.454c1.336-15.859-3.962-30.592-13.376-41.125c-5.998,45.563-11.65,91.164-16.848,136.818 c83.851,21.107,142.322,106.067,134.24,202.027c-6.848,81.317-59.513,146.804-127.875,169.042 c0.158,8.889,0.386,17.797,0.304,26.698c-0.224,24.153-1.79,48.356-3.38,72.538c6.633-1.34,13.191-2.939,19.661-4.81 c0.465,1.377,0.95,2.747,1.531,4.098c11.329,26.368,36.642,42.398,81.778,21.217c24.969-11.717,18.387-40.5,7.058-66.868 c-0.592-1.377-1.26-2.688-1.946-3.982c11.29-8.825,21.939-18.571,31.858-29.155c1.061,0.951,2.143,1.885,3.296,2.747 c22.078,16.533,71.604,7.252,87.185-16.85c15.581-24.101-8.688-53.894-30.764-70.426c-1.131-0.846-2.296-1.594-3.469-2.324 c5.727-13.56,10.506-27.701,14.289-42.324c1.354,0.24,2.717,0.457,4.111,0.572c26.91,2.269,50.714-19.516,53.168-48.655 c2.454-29.136-17.371-54.595-44.28-56.861c-1.395-0.118-2.774-0.132-4.149-0.123c-1.284-15.049-3.63-29.79-7.007-44.116 C3074.892,914.853,3076.167,914.31,3077.424,913.664z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000125579837835526701230000015563497203537265343_",
    gradientUnits: "userSpaceOnUse",
    x1: 2916.7583,
    y1: 815.4379,
    x2: 2164.6323,
    y2: 2467.302
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000125579837835526701230000015563497203537265343_)"
    },
    d: "M3100.987,1058.117 c26.909,2.266,50.714-19.517,53.168-48.655c2.453-29.137-17.371-54.596-44.281-56.862c-1.395-0.118-2.774-0.132-4.149-0.123 c-1.284-15.05-3.63-29.79-7.007-44.117c1.278-0.523,2.552-1.065,3.808-1.712c24.532-12.605,35.233-44.199,23.904-70.566 c-11.329-26.368-40.4-37.523-64.931-24.917c-1.283,0.66-2.505,1.4-3.71,2.159c-8.009-12.095-16.878-23.484-26.531-34.073 c0.891-1.16,1.77-2.341,2.584-3.601c15.58-24.099,10.312-57.039-11.764-73.57c-22.078-16.531-52.605-10.396-68.185,13.704 c-0.798,1.236-1.505,2.506-2.195,3.784c-12.463-6.015-25.474-10.994-38.947-14.891c0.239-1.468,0.458-2.945,0.585-4.455 c2.455-29.138-17.371-54.596-44.281-56.862c-26.909-2.266-50.713,19.517-53.167,48.655c-0.127,1.509-0.158,3.002-0.168,4.489 c-13.934,1.588-27.596,4.322-40.888,8.168c-0.466-1.375-0.952-2.746-1.531-4.098c-11.33-26.366-40.401-37.522-64.932-24.917 c-24.532,12.607-35.234,44.2-23.905,70.568c0.593,1.377,1.26,2.689,1.946,3.982c-11.289,8.824-21.939,18.57-31.859,29.155 c-1.061-0.951-2.141-1.884-3.295-2.749c-22.078-16.532-52.605-10.396-68.186,13.706s-10.313,57.039,11.765,73.57 c1.131,0.848,2.296,1.596,3.468,2.324c-5.727,13.561-10.505,27.701-14.288,42.325c-1.354-0.239-2.716-0.456-4.111-0.574 c-26.909-2.266-50.714,19.517-53.167,48.654c-2.455,29.138,17.37,54.596,44.28,56.862c1.395,0.117,2.775,0.131,4.149,0.123 c1.284,15.05,3.63,29.79,7.008,44.117c-1.278,0.524-2.553,1.066-3.809,1.711c-24.532,12.607-35.234,44.201-23.904,70.568 c11.329,26.368,40.4,37.522,64.932,24.916c1.282-0.658,2.504-1.397,3.709-2.157c8.009,12.095,16.878,23.484,26.533,34.073 c-0.893,1.161-1.771,2.342-2.584,3.602c-15.58,24.099-10.313,57.039,11.765,73.57c22.076,16.531,52.604,10.396,68.185-13.704 c0.797-1.236,1.505-2.506,2.194-3.784c12.463,6.015,25.475,10.994,38.947,14.892c-0.239,1.468-0.458,2.945-0.585,4.455 c-2.454,29.137,17.372,54.596,44.281,56.862c26.91,2.266,50.713-19.517,53.167-48.655c0.127-1.509,0.158-3.002,0.168-4.49 c13.935-1.588,27.596-4.322,40.888-8.168c0.466,1.376,0.951,2.746,1.531,4.098c11.329,26.366,40.4,37.522,64.932,24.917 c24.531-12.606,35.234-44.201,23.904-70.566c-0.593-1.378-1.261-2.69-1.947-3.983c11.29-8.825,21.939-18.571,31.859-29.155 c1.061,0.95,2.143,1.883,3.295,2.747c22.078,16.532,52.604,10.397,68.185-13.704c15.581-24.102,10.313-57.039-11.764-73.572 c-1.131-0.846-2.296-1.594-3.469-2.323c5.727-13.561,10.506-27.701,14.288-42.325 C3098.23,1057.782,3099.594,1057.999,3100.987,1058.117z M2824.313,1174.592c-97.703-8.228-169.683-100.66-160.772-206.452 c8.91-105.792,95.337-184.883,193.039-176.653c97.703,8.228,169.683,100.659,160.773,206.452 C3008.442,1103.732,2922.015,1182.822,2824.313,1174.592z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155852206060789560790000000717043816562910900_",
    gradientUnits: "userSpaceOnUse",
    x1: 2272.4707,
    y1: 1561.704,
    x2: 2703.4351,
    y2: 1561.704
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#893976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000155852206060789560790000000717043816562910900_)"
    },
    d: "M2666.798,1615.729 c18.471,1.555,34.811-13.397,36.497-33.399c1.684-20.001-11.924-37.476-30.396-39.032c-0.958-0.081-1.905-0.09-2.848-0.085 c-0.881-10.33-2.492-20.449-4.81-30.284c0.876-0.359,1.751-0.731,2.614-1.174c16.839-8.654,24.185-30.34,16.408-48.44 c-7.777-18.099-27.732-25.757-44.571-17.104c-0.881,0.453-1.719,0.961-2.547,1.482c-5.497-8.302-11.586-16.12-18.212-23.389 c0.612-0.797,1.215-1.607,1.774-2.471c10.695-16.543,7.079-39.154-8.075-50.503c-15.155-11.347-36.11-7.135-46.804,9.408 c-0.548,0.848-1.033,1.72-1.507,2.598c-8.555-4.129-17.487-7.548-26.735-10.223c0.164-1.008,0.315-2.022,0.402-3.057 c1.685-20.001,5.33-42.583-13.165-43.849c-42.781-2.93-52.043,18.214-53.728,38.214c-0.087,1.036-0.109,2.061-0.115,3.082 c-9.565,1.091-18.942,2.968-28.067,5.607c-0.32-0.944-0.653-1.885-1.051-2.813c-7.776-18.099-6.373-30.173-24.049-23.391 c-38.545,14.788-44.707,36.628-36.931,54.727c0.406,0.946,0.865,1.845,1.336,2.734c-7.749,6.057-15.06,12.747-21.869,20.013 c-0.728-0.652-1.47-1.293-2.262-1.887c-15.154-11.348-36.109-7.136-46.804,9.408c-10.695,16.544-7.079,39.154,8.076,50.502 c0.776,0.581,1.576,1.095,2.381,1.596c-3.931,9.308-7.211,19.015-9.808,29.053c-0.929-0.163-1.865-0.313-2.821-0.393 c-18.472-1.556-34.812,13.397-36.497,33.399c-1.685,20,11.924,37.476,30.396,39.032c0.957,0.08,1.905,0.09,2.848,0.084 c0.881,10.331,2.492,20.449,4.81,30.285c-0.876,0.359-1.751,0.731-2.614,1.173c-16.839,8.655-24.185,30.341-16.409,48.44 c7.777,18.1,27.732,25.757,44.572,17.104c0.88-0.452,1.719-0.96,2.546-1.482c5.498,8.302,11.586,16.12,18.212,23.389 c-0.612,0.796-1.215,1.607-1.773,2.472c-10.695,16.543-7.079,39.154,8.075,50.502c15.155,11.348,47.961,6.156,58.655-10.387 c0.548-0.848-10.817-0.74-10.344-1.618c8.555,4.129,17.486,7.548,26.734,10.222c-0.164,1.008-0.314,2.022-0.402,3.058 c-1.685,20.001,11.924,37.477,30.396,39.032c18.472,1.556,34.812-13.397,36.496-33.398c0.087-1.036,0.108-2.061,0.115-3.082 c9.566-1.09,18.943-2.967,28.068-5.606c0.32,0.944,0.652,1.884,1.051,2.813c7.776,18.099,27.732,25.757,44.572,17.103 c16.839-8.653,24.185-30.34,16.409-48.439c-0.407-0.946-0.865-1.846-1.336-2.733c7.75-6.058,15.06-12.748,21.869-20.014 c0.728,0.653,1.47,1.294,2.262,1.887c15.155,11.348,36.109,7.136,46.804-9.408c10.695-16.544,7.079-39.154-8.075-50.503 c-0.776-0.58-1.576-1.094-2.381-1.595c3.931-9.309,7.211-19.015,9.808-29.053 C2664.905,1615.499,2665.841,1615.648,2666.798,1615.729z M2476.879,1695.682c-67.067-5.649-116.477-69.097-110.361-141.717 c6.116-72.62,65.443-126.91,132.51-121.261c67.067,5.648,116.477,69.097,110.361,141.717 C2603.271,1647.041,2543.945,1701.331,2476.879,1695.682z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165914966883850669620000005945008141042154907_",
    gradientUnits: "userSpaceOnUse",
    x1: 2517.2405,
    y1: 1560.5977,
    x2: 2703.4346,
    y2: 1560.5977
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#893976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165914966883850669620000005945008141042154907_)"
    },
    d: "M2667.854,1511.755 c16.839-8.654,24.185-30.34,16.408-48.44c-7.777-18.099-27.732-25.757-44.572-17.104c-0.88,0.452-1.718,0.961-2.545,1.481 c-5.499-8.302-11.587-16.12-18.213-23.389c0.613-0.796,1.215-1.607,1.773-2.472c10.695-16.542,18.911-49.358,2.673-59.091 c-30.82-18.473-46.858,1.454-57.552,17.997c-0.548,0.848-1.033,1.719-1.507,2.597c-8.555-4.129-17.486-7.547-26.734-10.222 c0.164-1.008,0.315-2.022,0.402-3.057c0.917-10.886-2.72-21-9.182-28.23c-4.117,31.276-7.997,62.578-11.565,93.917 c57.558,14.489,97.695,72.808,92.147,138.679c-4.701,55.819-40.852,100.772-87.778,116.036 c0.109,6.101,0.265,12.217,0.209,18.327c-0.154,16.579-1.229,33.193-2.321,49.793c4.553-0.92,9.055-2.018,13.496-3.302 c0.319,0.945,0.652,1.885,1.051,2.813c7.777,18.1,25.153,29.104,56.135,14.564c17.14-8.043,12.622-27.801,4.845-45.901 c-0.406-0.945-0.865-1.845-1.336-2.733c7.75-6.058,15.06-12.748,21.869-20.013c0.728,0.653,1.471,1.294,2.262,1.886 c15.155,11.349,49.152,4.978,59.847-11.567c10.695-16.544-5.964-36.994-21.118-48.343c-0.776-0.581-1.576-1.094-2.382-1.595 c3.931-9.308,7.212-19.015,9.808-29.052c0.93,0.165,1.865,0.314,2.822,0.393c18.472,1.557,34.812-13.396,36.497-33.398 c1.685-20-11.924-37.476-30.396-39.031c-0.958-0.081-1.904-0.09-2.848-0.085c-0.881-10.33-2.492-20.449-4.81-30.283 C2666.117,1512.571,2666.992,1512.198,2667.854,1511.755z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075135440744528203130000006596122150935666073_",
    gradientUnits: "userSpaceOnUse",
    x1: 2557.5681,
    y1: 1444.329,
    x2: 2041.2815,
    y2: 2578.2285
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000075135440744528203130000006596122150935666073_)"
    },
    d: "M2684.029,1610.912 c18.472,1.556,34.812-13.397,36.497-33.399c1.684-20.001-11.924-37.477-30.396-39.032c-0.958-0.081-1.904-0.09-2.848-0.085 c-0.882-10.331-2.491-20.449-4.81-30.284c0.877-0.359,1.751-0.731,2.614-1.175c16.84-8.652,24.185-30.339,16.409-48.439 c-7.776-18.1-27.732-25.757-44.571-17.104c-0.881,0.453-1.719,0.961-2.547,1.482c-5.498-8.302-11.586-16.12-18.212-23.389 c0.612-0.797,1.215-1.607,1.773-2.472c10.695-16.542,7.079-39.154-8.075-50.501c-15.155-11.347-36.11-7.136-46.805,9.407 c-0.548,0.849-1.033,1.72-1.507,2.598c-8.555-4.129-17.486-7.547-26.735-10.222c0.164-1.008,0.315-2.022,0.402-3.058 c1.685-20.001-11.925-37.477-30.396-39.032c-18.471-1.556-34.811,13.397-36.496,33.398c-0.087,1.036-0.109,2.061-0.115,3.082 c-9.565,1.09-18.943,2.967-28.067,5.607c-0.32-0.944-0.653-1.885-1.051-2.813c-7.777-18.099-27.733-25.756-44.572-17.104 c-16.84,8.654-24.186,30.341-16.409,48.44c0.407,0.945,0.865,1.846,1.336,2.734c-7.749,6.057-15.06,12.747-21.869,20.013 c-0.728-0.653-1.47-1.293-2.261-1.887c-15.155-11.348-36.11-7.136-46.805,9.408c-10.695,16.544-7.079,39.154,8.076,50.501 c0.776,0.582,1.576,1.095,2.381,1.595c-3.931,9.309-7.211,19.015-9.808,29.053c-0.929-0.164-1.864-0.313-2.822-0.394 c-18.472-1.556-34.812,13.397-36.496,33.398c-1.685,20.001,11.924,37.477,30.395,39.032c0.957,0.081,1.905,0.09,2.848,0.084 c0.881,10.331,2.492,20.449,4.811,30.284c-0.877,0.36-1.752,0.732-2.615,1.175c-16.84,8.654-24.186,30.341-16.409,48.44 c7.776,18.1,27.732,25.757,44.571,17.103c0.88-0.452,1.719-0.959,2.546-1.481c5.498,8.302,11.586,16.12,18.213,23.389 c-0.613,0.797-1.216,1.608-1.774,2.472c-10.695,16.542-7.079,39.154,8.076,50.501c15.154,11.348,36.109,7.136,46.804-9.407 c0.547-0.848,1.033-1.72,1.506-2.597c8.555,4.129,17.487,7.547,26.734,10.222c-0.164,1.008-0.314,2.021-0.402,3.058 c-1.684,20.001,11.925,37.476,30.396,39.032c18.472,1.556,34.812-13.397,36.496-33.398c0.087-1.036,0.109-2.061,0.115-3.082 c9.566-1.09,18.943-2.967,28.068-5.607c0.32,0.945,0.653,1.885,1.051,2.813c7.777,18.099,27.732,25.757,44.572,17.104 c16.839-8.653,24.186-30.341,16.409-48.439c-0.407-0.946-0.865-1.846-1.336-2.734c7.75-6.058,15.06-12.748,21.869-20.013 c0.728,0.652,1.471,1.293,2.262,1.886c15.155,11.348,36.11,7.137,46.805-9.407c10.695-16.544,7.079-39.154-8.075-50.502 c-0.776-0.581-1.576-1.094-2.381-1.595c3.931-9.309,7.212-19.015,9.808-29.053 C2682.137,1610.683,2683.073,1610.831,2684.029,1610.912z M2494.11,1690.866c-67.067-5.648-116.476-69.096-110.36-141.716 c6.116-72.62,65.442-126.91,132.509-121.261c67.067,5.648,116.477,69.096,110.361,141.716 C2620.503,1642.225,2561.177,1696.515,2494.11,1690.866z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000175287035121299349070000003544836331491787406_",
    gradientUnits: "userSpaceOnUse",
    x1: 2444.801,
    y1: 2208.6389,
    x2: 2439.5537,
    y2: 2145.6689,
    gradientTransform: "matrix(-0.9986 0.0537 0.0537 0.9986 3020.4207 -55.8024)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#26264F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#444B8C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000175287035121299349070000003544836331491787406_)"
    },
    d: "M717.459,2266.943 c5.32-10.478,7.856-12.628,5.929-17.974c-4.46-12.37-10.495-7.927-17.014-8.15c-4.203-0.143,4.126-12.269-4.77-2.084 c-10.9,12.475-17.515,10.838-23.929,21.667c-1.501,2.533-8.253,13.936-4.101,22.445c5.299,10.861,26.195,12.581,34.929,4.203 C712.645,2283.078,710.905,2279.852,717.459,2266.943z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062191282943850944280000002932219235908524456_",
    gradientUnits: "userSpaceOnUse",
    x1: 2421.3711,
    y1: 2072.8262,
    x2: 2428.4836,
    y2: 2335.9807,
    gradientTransform: "matrix(-0.9986 0.0537 0.0537 0.9986 3020.4207 -55.8024)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#F36F56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC444"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062191282943850944280000002932219235908524456_)"
    },
    d: "M697.523,2276.686 c0,0,4.337,23.146,1.25,41.965c-2.791,17.009-34.299,34.678-40.338,39.745c-6.039,5.066,16.017,10.564,36.251,7.916 c20.233-2.647,75.631-20.374,84.049-30.254c8.419-9.879-9.802-5.012-25.126-6.882c-15.324-1.871-29.953-27.552-30.399-40.659 C722.764,2275.406,697.523,2276.686,697.523,2276.686z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016039550051516814000000004976755402287211946_",
    gradientUnits: "userSpaceOnUse",
    x1: 49.8043,
    y1: 1917.5151,
    x2: 110.1887,
    y2: 1981.1635,
    gradientTransform: "matrix(0.966 -0.2584 0.2584 0.966 113.1373 402.9503)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#F36F56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC444"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000016039550051516814000000004976755402287211946_)"
    },
    d: "M707.472,2293.114 c0,0,13.327,5.852,25.131-3.587c10.569-8.452-5.146-34.415-15.897-34.746c-3.587-0.111-8.822,2.459-11.913,6.219 c-1.826,2.221-1.934,3.7-4.988,7.271c-2.816,3.292-4.054,3.59-4.482,5.189c-0.536,1.999,0.384,5.342,7.621,11.088 c-3.606-0.665-6.715,0.285-7.919,2.387c-0.192,0.335-0.591,1.384-0.472,2.466 C694.986,2293.317,700.104,2295.131,707.472,2293.114z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016040237871991732690000013533015792368783784_",
    gradientUnits: "userSpaceOnUse",
    x1: 1264.2374,
    y1: 2029.8723,
    x2: 771.1407,
    y2: 2432.5398
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#F36F56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2815,
    style: {
      stopColor: "#F68751"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3765,
    style: {
      stopColor: "#F78F4F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC444"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000016040237871991732690000013533015792368783784_)"
    },
    d: "M1044.521,2213.453 c0,0,9.381-1.307,6.456-19.223c-2.292-14.043-0.556-18.766,2.759-16.276c3.315,2.489,3.783,10.605,3.783,10.605 s12.091-10.313,17.07-23.827c4.979-13.514,8.18-2.134,9.247,4.624c1.067,6.757-7.113,27.739-11.736,31.651 c-4.623,3.912-11.38,21.153-11.38,21.153L1044.521,2213.453z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000056425946986819681440000013104192443853516732_",
    gradientUnits: "userSpaceOnUse",
    x1: 421.1175,
    y1: 3289.6223,
    x2: 373.9579,
    y2: 3134.123,
    gradientTransform: "matrix(0.9999 0.0138 -0.0138 0.9999 366.8176 -14.86)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000056425946986819681440000013104192443853516732_)"
    },
    d: "M697.583,3204.255 c-4.826,9.844-3.472,14.076-2.27,15.936c3.523,5.461,12.002,0.304,34.14,2.926c2.597,0.308,7.551,0.978,13.735-0.479 c5.297-1.249,11.542-4.068,11.276-5.487c-0.098-0.517-1.039-0.724-1.396-0.799c-6.143-1.31-44.601-13.112-44.601-13.112 L697.583,3204.255z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062907080280980181230000001445057158370005404_",
    gradientUnits: "userSpaceOnUse",
    x1: 380.4639,
    y1: 3259.3411,
    x2: 380.4639,
    y2: 3009.53,
    gradientTransform: "matrix(0.9999 0.0138 -0.0138 0.9999 366.8176 -14.86)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062907080280980181230000001445057158370005404_)"
    },
    d: "M694.632,3182.614l3.434,22.008 c0,0,9.452,6.682,11.936-1.429c1.787-5.835,1.737-21.561,1.737-21.561L694.632,3182.614z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150794515106487360640000004323121185872860602_",
    gradientUnits: "userSpaceOnUse",
    x1: 468.473,
    y1: 3250.0134,
    x2: 468.473,
    y2: 3000.1907,
    gradientTransform: "matrix(0.9999 0.0138 -0.0138 0.9999 366.8176 -14.86)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000150794515106487360640000004323121185872860602_)"
    },
    points: "802.405,3184.124  793.125,3209.463 779.64,3207.315 782.766,3183.852  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114795139172273957920000012180738566303170208_",
    gradientUnits: "userSpaceOnUse",
    x1: 485.8425,
    y1: 3259.457,
    x2: 438.6832,
    y2: 3103.9587,
    gradientTransform: "matrix(0.9999 0.0138 -0.0138 0.9999 366.8176 -14.86)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000114795139172273957920000012180738566303170208_)"
    },
    d: "M788.926,3223.419 c-6.528-7.746-12.355-7.043-13.531-12.366c-0.924-4.182,1.637-9.312,5.501-11.26c5.432-2.737,12.01,1.539,13.496,2.504 c10.096,6.563,7.346,16.827,16.866,21.278c1.916,0.896,4.952,1.846,8.152,4.845c1.359,1.274,4.725,4.427,3.936,6.6 c-0.912,2.513-6.914,2.426-12.62,2.343c-6.848-0.098-10.271-0.146-13.564-2.202 C792.597,3232.312,793.964,3229.396,788.926,3223.419z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000161602331060782570400000006376206601804598926_",
    gradientUnits: "userSpaceOnUse",
    x1: 358.8802,
    y1: 2720.2908,
    x2: 335.9381,
    y2: 3236.4897,
    gradientTransform: "matrix(0.9999 0.0138 -0.0138 0.9999 366.8176 -14.86)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#893976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000161602331060782570400000006376206601804598926_)"
    },
    d: "M622.474,2656.216 c2.495,51.188,9.824,94.885,18.161,130.507c8.969,38.32,13.855,44.87,16.966,71.434c6.768,57.806-11.722,66.497-13.745,132.042 c-2.235,72.375,18.221,129.421,26.248,151.177c7.018,19.019,14.265,34.344,19.697,44.98c6.752,5.637,16.839,3.2,27.477,0.799 c2.531-65.657,6.114-127.471,8.645-193.128c10.579-98.917,21.157-197.829,31.736-296.745 C712.597,2683.592,667.536,2669.906,622.474,2656.216z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000133509595976189338630000001012228301108946090_",
    gradientUnits: "userSpaceOnUse",
    x1: 358.8802,
    y1: 2720.2905,
    x2: 335.9381,
    y2: 3236.4895,
    gradientTransform: "matrix(0.9999 0.0138 -0.0138 0.9999 366.8176 -14.86)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#893976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000133509595976189338630000001012228301108946090_)"
    },
    d: "M717.278,3187.155 c2.531-65.657,6.114-127.471,8.645-193.128c10.579-98.917,21.157-197.829,31.736-296.745 c-45.062-13.69-90.124-27.376-135.186-41.066c0.166,3.39,0.406,6.657,0.612,9.983c63.95,53.173,77.163,96.099,77.182,125.572 c0.023,35.746-19.135,53.877-14.207,105.6c3.524,36.982,14.799,43.269,15.511,76.695c0.916,43.041-17.037,67.637-25.5,92.701 c-8.179,24.224-10.544,58.338,7.292,106.404c2.313,4.954,4.494,9.383,6.436,13.185 C696.553,3191.991,706.639,3189.558,717.278,3187.155z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000141430270942839444880000010844078847159109520_",
    gradientUnits: "userSpaceOnUse",
    x1: 774.3595,
    y1: 2933.7288,
    x2: 268.7011,
    y2: 2910.7439,
    gradientTransform: "matrix(0.9999 0.0138 -0.0138 0.9999 366.8176 -14.86)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#893976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000141430270942839444880000010844078847159109520_)"
    },
    d: "M698.914,2694.469 c40.551,49.657,63.68,96.081,77.025,128.604c16.057,39.13,27.697,68.456,24.049,106.439 c-4.016,41.803-22.973,56.826-35.563,92.464c-12.21,34.563-18.16,87.746,13.696,166.885c8.016,2.776,16.033,5.551,24.048,8.324 c5.326-21.385,13.942-53.375,26.824-91.472c25.528-75.494,50.973-125.174,57.854-140.604 c24.233-54.342,26.682-151.356-74.184-338.54C774.746,2649.201,736.83,2671.833,698.914,2694.469z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176761367030580835150000003056850291953564575_",
    gradientUnits: "userSpaceOnUse",
    x1: 2369.21,
    y1: 2350.8115,
    x2: 2460.251,
    y2: 2824.9844,
    gradientTransform: "matrix(-1 0 0 1 3206 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#E38DDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9571F6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176761367030580835150000003056850291953564575_)"
    },
    d: "M1069.516,2218.253 c-10.671-7.474-21.342-14.945-32.012-22.419c-12.984,79.814-42.497,111.137-67.564,124.84 c-60.473,33.054-114.444-25.85-230.194-1.811c-31.897,6.624-87.495,18.962-118.323,64.403 c-8.104,11.944-10.987,20.988-24.443,106.672c-17.201,109.528-17.813,128.643-15.387,152.226 c4.438,43.159,7.128,69.315,27.028,92.464c52.842,61.471,165.156,29.776,179.237,25.605 c26.013-7.705,66.443-19.682,82.506-54.056c7.558-16.173,6.755-30.959-4.861-90.105 c-23.01-117.163-25.95-124.746-19.527-137.576c21.675-43.298,90.355-18.523,148.372-58.787 C1028.271,2396.167,1066.508,2344.865,1069.516,2218.253z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181776425079564927750000000359197474904321927_",
    gradientUnits: "userSpaceOnUse",
    x1: 2295.2493,
    y1: 2365.0117,
    x2: 2386.2903,
    y2: 2839.1848,
    gradientTransform: "matrix(-1 0 0 1 3206 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#E38DDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9571F6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000181776425079564927750000000359197474904321927_)"
    },
    d: "M735.224,2744.585 c11.325-23.227-3.894-44.631,12.803-72.549c21.279-35.58,59.565-23.5,73.971-49.788 c24.637-44.959-72.339-107.661-52.633-179.237c9.408-34.174,42.26-58.91,69.703-68.281 c60.927-20.805,100.78,32.229,157.9,15.647c13.538-3.931,29.077-12.074,44.793-28.973 c-13.891,29.306-31.143,47.012-47.413,58.304c-58.017,40.264-126.697,15.489-148.372,58.787 c-6.423,12.83-3.483,20.413,19.527,137.576c11.616,59.146,12.419,73.932,4.861,90.105 c-16.063,34.374-56.493,46.351-82.506,54.056c-7.708,2.284-44.856,12.783-85.564,11.766 C720.455,2764.619,730.229,2754.831,735.224,2744.585z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000043459169615834746470000004505890031712822455_",
    gradientUnits: "userSpaceOnUse",
    x1: 7025.0088,
    y1: -3877.7468,
    x2: 7126.0977,
    y2: -3797.5178,
    gradientTransform: "matrix(-0.1272 0.9919 0.9919 0.1272 5430.3882 -4213.8569)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000043459169615834746470000004505890031712822455_)"
    },
    d: "M711.494,2237.007 c0,0-19.688,31.456-26.679,48.552c-1.239,3.029-4.847,4.304-7.691,2.685c-8.598-4.895-22.725-16.55-12.75-36.938 C676.979,2225.541,697.192,2228.435,711.494,2237.007z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000032607202138737252260000015650195189068873114_",
    gradientUnits: "userSpaceOnUse",
    x1: 7010.9219,
    y1: -3840.9436,
    x2: 7014.5576,
    y2: -3860.7388,
    gradientTransform: "matrix(-0.1272 0.9919 0.9919 0.1272 5430.3882 -4213.8569)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000032607202138737252260000015650195189068873114_)"
    },
    d: "M707.812,2236.535 c0,0,8.973-9.625,11.069-6.913c2.096,2.713-30.166,47.42-30.166,47.42L707.812,2236.535z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052067711372958780400000011535969816642434736_",
    gradientUnits: "userSpaceOnUse",
    x1: 6996.9258,
    y1: -3900.4521,
    x2: 7048.6348,
    y2: -3839.0471,
    gradientTransform: "matrix(-0.1272 0.9919 0.9919 0.1272 5430.3882 -4213.8569)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052067711372958780400000011535969816642434736_)"
    },
    d: "M674.567,2252.613 c-3.557-1.775-7.713-0.436-11.659,2.113c0.419-1.114,0.893-2.249,1.466-3.42c11.164-22.819,28.293-23.153,42-16.976 c-3.313,5.428-6.946,11.511-8.746,14.968C693.85,2256.551,685.118,2257.875,674.567,2252.613z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021813566359408477820000013361102937492221614_",
    gradientUnits: "userSpaceOnUse",
    x1: 4713.9727,
    y1: 3120.5381,
    x2: 4727.4019,
    y2: 3291.4548,
    gradientTransform: "matrix(1 0 0 1 -2016.7148 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#26264F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#444B8C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021813566359408477820000013361102937492221614_)"
    },
    d: "M2721.549,3206.027 c0,0-48.197,24.491-48.983,28.401c-0.787,3.91,30.995-1.311,43.969-0.747c12.975,0.564,23.648-3.723,22.474-9.867 c-1.175-6.146-5.716-21.599-5.716-21.599L2721.549,3206.027z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178892121139181274080000000803555548008661173_",
    gradientUnits: "userSpaceOnUse",
    x1: 4745.8682,
    y1: 3215.9121,
    x2: 4743.4331,
    y2: 3039.3706,
    gradientTransform: "matrix(1 0 0 1 -2016.7148 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000178892121139181274080000000803555548008661173_)"
    },
    d: "M2719.786,3186.151l2.932,24.262 c0,0,7.63,3.037,12.756-0.554l2.187-26.61L2719.786,3186.151z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000032633675284502984550000008446444234965798030_",
    gradientUnits: "userSpaceOnUse",
    x1: 4940.1216,
    y1: 3100.5476,
    x2: 4953.5859,
    y2: 3271.9136,
    gradientTransform: "matrix(1 0 0 1 -2016.7148 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#26264F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#444B8C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000032633675284502984550000008446444234965798030_)"
    },
    d: "M2946.76,3186.733l5.606,10.063 c1.568,2.813,2.034,6.201,1.283,9.408c-1.96,8.368-5.875,24.675-7.583,28.927c-2.325,5.791-33.514,9.232-33.514,9.232 s-2.782-4.376,3.694-9.661c6.475-5.286,10.638-6.117,12.923-13.917c2.285-7.799,3.81-29.862,3.81-29.862L2946.76,3186.733z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109743253738626421730000011781451436597636003_",
    gradientUnits: "userSpaceOnUse",
    x1: 4953.2358,
    y1: 3212.7139,
    x2: 4950.8013,
    y2: 3036.1953,
    gradientTransform: "matrix(1 0 0 1 -2016.7148 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109743253738626421730000011781451436597636003_)"
    },
    d: "M2923.426,3161.163 c2.048,1.825,12.065,35.82,12.065,35.82s3.242,4.635,9.402-2.206c6.159-6.842,2.787-3.069,2.787-3.069l-1.155-33.435 L2923.426,3161.163z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060739580561872497490000009004192955031556272_",
    gradientUnits: "userSpaceOnUse",
    x1: 4081.895,
    y1: 2930.0505,
    x2: 4198.5864,
    y2: 2930.0505,
    gradientTransform: "matrix(1 0 0 1 -1390.4521 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000060739580561872497490000009004192955031556272_)"
    },
    d: "M2693.268,2698.712 c-2.543,72.373-2.646,151.003,1.078,235.004c4.193,94.592,12.62,182.017,23.24,261.269c3.948,0.141,8.096,0.164,12.43,0.028 c2.927-0.091,5.762-0.251,8.502-0.462c5.511-16.434,12.026-38.044,17.859-63.856c6.133-27.142,9.833-51.489,12.468-74.77 c9.281-81.973-1.595-89.124,5.937-149.874c6.671-53.803,16.157-55.904,27.294-132.292c12.083-82.883,3.088-95.318-1.286-99.81 C2782.169,2654.827,2738.427,2667.845,2693.268,2698.712z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134212726257711176040000002019990120895699106_",
    gradientUnits: "userSpaceOnUse",
    x1: 4089.9634,
    y1: 2930.0559,
    x2: 4198.5859,
    y2: 2930.0559,
    gradientTransform: "matrix(1 0 0 1 -1390.4521 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000134212726257711176040000002019990120895699106_)"
    },
    d: "M2800.791,2673.95 c-17.761-18.241-58.379-7.198-101.28,20.64c49.353,59.618,54.734,98.292,48.817,123.385 c-6.687,28.362-27.016,36.53-26.939,67.542c0.096,38.111,30.858,48.206,30.205,88.534 c-0.433,26.667-13.951,26.39-17.143,59.327c-3.777,38.971,13.883,52.4,8.163,81.233c-2.461,12.404-9.484,28.613-29.489,45.311 c1.442,11.841,2.921,23.562,4.463,35.062c3.946,0.139,8.095,0.164,12.429,0.026c2.927-0.09,5.762-0.249,8.502-0.46 c5.511-16.434,12.026-38.043,17.859-63.855c6.133-27.143,9.833-51.49,12.468-74.771c9.281-81.972-1.595-89.124,5.937-149.874 c6.671-53.803,16.157-55.905,27.293-132.292C2814.159,2690.875,2805.165,2678.441,2800.791,2673.95z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127028601257023761150000016696870555565141138_",
    gradientUnits: "userSpaceOnUse",
    x1: 4114.2905,
    y1: 2917.1897,
    x2: 4349.2031,
    y2: 2917.1897,
    gradientTransform: "matrix(1 0 0 1 -1390.4521 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000127028601257023761150000016696870555565141138_)"
    },
    d: "M2723.838,2697.497 c42.495,69.521,88.331,156.042,129.321,259.604c30.977,78.263,53.444,151.745,69.938,217.233 c2.232,1.156,7.498,3.46,14.226,2.466c9.176-1.357,14.677-7.906,16.114-9.734c6.713-46.946,5.974-86.706,3.695-115.401 c-1.459-18.373-4.041-48.968-14.515-86.738c-11.732-42.309-19.797-44.687-35.103-89.448 c-15.886-46.461-12.038-58.054-27.251-116.197c-6.249-23.885-16.711-59.429-33.974-101.945 C2805.471,2670.723,2764.655,2684.11,2723.838,2697.497z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000020378953348253198950000011287286494014733997_",
    gradientUnits: "userSpaceOnUse",
    x1: 947.8821,
    y1: 2455.2695,
    x2: 1511.3988,
    y2: 2455.2695,
    gradientTransform: "matrix(-1 0 0 1 4135.2749 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#893976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000020378953348253198950000011287286494014733997_)"
    },
    d: "M2682.583,2399.081 c-40.386-38.856-46.985-36.764-55.219-66.342c-8.143-29.256-2.701-79.908,23.44-98.239c1.919-1.346,8.249-15.383,27.143-2.037 c9.939,7.021,17.978,37.437,52.485,64.433c29.239,22.876,81.886,34.948,107.318,31.525 c61.241-8.24,76.676-42.879,105.445-31.432c36.05,14.344,27.942,75.146,64.522,85.928 c24.449,7.206,35.346-17.809,69.472-18.792c40.1-1.156,77.594,31.872,95.512,66.782c32.75,63.81,5.599,144.624-31.105,190.134 c-30.153,37.389-87.091,76.173-125.451,58.226c-30.305-14.178-33.056-56.292-61.213-57.496 c-20.019-0.854-24.74,20.172-49.831,26.694c-41.205,10.71-81.415-32.234-92.384-43.949 c-31.263-33.39-22.267-49.242-58.981-111.255C2739.233,2468.767,2718.348,2433.488,2682.583,2399.081z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011716868407082344000000010547486468643142554_",
    gradientUnits: "userSpaceOnUse",
    x1: 3725.124,
    y1: 2259.6736,
    x2: 3766.9119,
    y2: 2259.6736,
    gradientTransform: "matrix(1 0 0 1 -1390.4521 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000011716868407082344000000010547486468643142554_)"
    },
    d: "M2376.46,2276.234 c0,0-7.93-11.095-12.961-19.34c-5.031-8.245-28.519-31.41-28.519-31.41s-1.79,3.676,3.267,9.558 c5.056,5.882,15.696,15.962,13.25,20.227c-2.447,4.265-9.334,8.024-4.364,16.077c4.971,8.052,13.614,2.553,18.032,9.012 c4.418,6.459,8.944,13.505,8.944,13.505L2376.46,2276.234z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059284816121022759190000000803855989010024618_",
    gradientUnits: "userSpaceOnUse",
    x1: 1615.1879,
    y1: 2404.209,
    x2: 1448.8004,
    y2: 2966.0674,
    gradientTransform: "matrix(-1 0 0 1 4135.2749 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000059284816121022759190000000803855989010024618_)"
    },
    d: "M2379.554,2268.994 c-5.348,9.048-10.697,18.092-16.045,27.14c5.568,18.186,15.166,43.438,31.981,70.082c7.417,11.753,30.413,46.23,69.346,73.957 c53,37.742,149.557,72.955,177.822,32.791c25.222-35.838-15.488-115.275-22.984-129.537 c-15.173,7.954-40.106,18.504-72.156,20.999c-10.503,0.818-37.842,2.681-68.641-7.897 C2421.877,2336.951,2390.232,2287.54,2379.554,2268.994z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078749184198182730500000016474656860346008254_",
    gradientUnits: "userSpaceOnUse",
    x1: 1406.1307,
    y1: 2342.2991,
    x2: 1239.7439,
    y2: 2904.1558,
    gradientTransform: "matrix(-1 0 0 1 4135.2749 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078749184198182730500000016474656860346008254_)"
    },
    d: "M2557.837,2390.251 c2.667,13.402,44.352,6.215,52.956,30.542c4.616,13.054-5.185,21.346-5.596,43.516c-0.46,24.819,11.37,38.914,20.445,58.438 c13.291,28.597,13.34,56.63,13.439,112.691c0.14,79.804-17.506,95.851-2.444,121.572c19.606,33.479,66.686,35.616,79.41,36.196 c43.519,1.977,48.682-21.142,95.903-23.903c53.93-3.153,61.611,26.16,100.18,13.658c35.233-11.421,47.089-41.803,74.524-35.512 c17.147,3.93,21.694,17.904,37.872,16.391c16.257-1.521,33.062-17.632,34.208-34.151c1.424-20.533-21.022-46.401-56.198-46.441 c-13.978,5.486-37.148,11.845-62.917,4.782c-42.222-11.573-64.182-51.715-88.573-96.299 c-16.874-30.842-47.888-87.532-48.257-161.865c-0.153-30.654,5.029-39.622-2.443-56.006 c-24.263-53.204-118.398-45.265-126.369-44.496C2609.833,2335.546,2554.616,2374.068,2557.837,2390.251z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152243911920157116300000013394053251752807605_",
    gradientUnits: "userSpaceOnUse",
    x1: 4031.4302,
    y1: 2521.6611,
    x2: 3958.3052,
    y2: 2642.8684,
    gradientTransform: "matrix(1 0 0 1 -1390.4521 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#6165D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AA80F9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000152243911920157116300000013394053251752807605_)"
    },
    d: "M2536.807,2457.21l118.238,5.159 c1.298,0.056,2.436,0.988,2.876,2.354l55.7,172.763c0.799,2.478-1.706,8.677-4.048,8.395l-116.9-17.781 c-1.188-0.143-2.206-1.018-2.635-2.265l-57.95-161.256C2531.266,2462.188,2534.518,2457.11,2536.807,2457.21z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031206409373291282710000008511634261160673458_",
    gradientUnits: "userSpaceOnUse",
    x1: 4081.1479,
    y1: 2517.3008,
    x2: 3899.9834,
    y2: 2613.7273,
    gradientTransform: "matrix(1 0 0 1 -1390.4521 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB316D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#792D3D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031206409373291282710000008511634261160673458_)"
    },
    d: "M2534.972,2461.438l118.238,5.159 c1.298,0.056,2.436,0.988,2.876,2.354l55.699,172.764c0.799,2.478-0.999,5.035-3.341,4.754l-117.606-14.14 c-1.189-0.143-2.207-1.018-2.636-2.265l-56.331-163.783C2531.049,2463.89,2532.683,2461.338,2534.972,2461.438z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000148624124742062178280000005538995845451120053_",
    gradientUnits: "userSpaceOnUse",
    x1: 3998.7898,
    y1: 2394.5881,
    x2: 3977.2891,
    y2: 2464.9543,
    gradientTransform: "matrix(1 0 0 1 -1390.4521 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#26264F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#444B8C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000148624124742062178280000005538995845451120053_)"
    },
    d: "M2567.304,2467.872l-4.556-13.773 c-0.412-1.243,0.411-2.565,1.597-2.565h43.039c0.742,0,1.398,0.537,1.623,1.328l4.327,15.234 c0.355,1.251-0.501,2.52-1.675,2.479l-42.809-1.461C2568.156,2469.091,2567.545,2468.6,2567.304,2467.872z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000115502037616721039450000006433501961200975547_",
    gradientUnits: "userSpaceOnUse",
    x1: 4074.1428,
    y1: 2505.6863,
    x2: 3893.8955,
    y2: 2601.6245,
    gradientTransform: "matrix(1 0 0 1 -1390.4521 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB316D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#792D3D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000115502037616721039450000006433501961200975547_)"
    },
    d: "M2640.088,2604.648 c-7.68-27.844,4.959-45.977-7.941-67.615c-18.248-30.605-57.449-17.652-69.637-42.347c-3.287-6.659-4.859-16.583-0.425-32.066 l-27.113-1.181c-2.29-0.1-3.923,2.449-3.101,4.842l56.331,163.783c0.429,1.248,1.447,2.121,2.636,2.265l71.476,8.596 C2649.583,2628.511,2643.209,2615.966,2640.088,2604.648z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150822587223996297240000005996559243331357837_",
    gradientUnits: "userSpaceOnUse",
    x1: 4050.9036,
    y1: 2580.3809,
    x2: 4116.8833,
    y2: 2580.3809,
    gradientTransform: "matrix(1 0 0 1 -1390.4521 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150822587223996297240000005996559243331357837_)"
    },
    d: "M2726.431,2583.958 c0,0-17.867-3.974-24.758-8.823c-6.891-4.852-14.198-12.643-24.358-12.219c-10.159,0.428-20.383,6.201-15.69,7.528 c4.694,1.324,13.46,11.733,20.157,15.832c6.697,4.098,22.001,4.468,24.851,4.245c2.85-0.223,14.1,7.342,14.1,7.342 L2726.431,2583.958z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000061436537136660200300000004196293055249788579_",
    gradientUnits: "userSpaceOnUse",
    x1: 4021.0017,
    y1: 2579.9187,
    x2: 4449.25,
    y2: 2579.9187,
    gradientTransform: "matrix(1 0 0 1 -1390.4521 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "url(#SVGID_00000061436537136660200300000004196293055249788579_)"
    },
    d: "M3002.535,2683.248 c-13.978,5.486-37.148,11.845-62.917,4.782c-42.222-11.573-64.183-51.715-88.573-96.299 c-16.874-30.842-47.888-87.532-48.257-161.865c-0.153-30.654,5.029-39.622-2.443-56.006c-1.189-2.605-2.591-5.026-4.096-7.347 c-18.432,13.93-25.579,27.881-27.668,40.13c-5.083,29.814,18.888,54.193,6.414,79.908 c-11.948,24.631-41.488,17.816-47.646,38.93c-6.644,22.778,26.047,36.516,27.488,71.712 c1.73,42.24-43.696,62.925-35.734,91.178c6.9,24.487,44.916,22.722,44.897,35.856c-0.023,15.615,1.175-16.627-44.897-35.856 c-13.963-5.827-79.678,42.676-87.665,34.163c-1.72,13.762-1.41,23.191,5.2,34.476c19.606,33.479,66.686,35.616,79.41,36.196 c43.519,1.977,48.682-21.142,95.903-23.903c53.93-3.153,61.611,26.16,100.18,13.658c35.233-11.421,47.089-41.803,74.524-35.512 c17.147,3.93,21.694,17.904,37.872,16.391c16.257-1.521,33.062-17.632,34.208-34.151 C3060.158,2709.156,3037.711,2683.288,3002.535,2683.248z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160169054801235433110000011608917162916855700_",
    gradientUnits: "userSpaceOnUse",
    x1: 1383.3037,
    y1: 2335.5393,
    x2: 1216.9163,
    y2: 2897.3977,
    gradientTransform: "matrix(-1 0 0 1 4135.2749 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160169054801235433110000011608917162916855700_)"
    },
    d: "M2725.973,2575.679 c-5.498,10.929-10.995,21.854-16.493,32.783c8.476,4.642,99.094,52.58,164.776,5.123c8.122-5.867,29.705-21.462,41.338-52 c12.822-33.659,5.63-64.953,0.964-85.279c-11.55-50.315-44.214-103.095-90.559-124.3c-17.702-8.1-38.72-12.198-58.489-16.052 c-16.765-3.27-43.114-7.275-43.675-4.438c-0.274,1.385,5.849,3.153,10.1,5.843c26.114,16.515-7.042,84.723,23.649,117.433 c29.4,31.334,67.557,26.16,73.707,54.557c2.859,13.202-3.059,25.079-5.695,30.37 C2810.886,2569.24,2771.29,2582.454,2725.973,2575.679z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000104695011530519922610000005644545551528556694_",
    gradientUnits: "userSpaceOnUse",
    x1: 4166.7632,
    y1: 2893.9287,
    x2: 4251.1973,
    y2: 2771.363,
    gradientTransform: "matrix(0.9787 -0.2054 0.2054 0.9787 -2005.2675 371.9818)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000104695011530519922610000005644545551528556694_)"
    },
    d: "M2664.468,2280.308 c0,0,10.642,34.59,23.896,39.978c13.254,5.383,34.207,11.566,36.837,13.963c2.629,2.392-70.417,28.913-111.374,16.707l0,0 c11.67-5.709,14.792-7.535,14.792-7.535c3.116-1.825,8.93-5.221,14.383-10.621c3.712-3.674,9.524-10.513,13.898-21.878 l-3.828-19.638L2664.468,2280.308z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000123412721730175390800000009363682506244899768_",
    gradientUnits: "userSpaceOnUse",
    x1: 4157.1841,
    y1: 2833.7756,
    x2: 4306.4111,
    y2: 2743.9348,
    gradientTransform: "matrix(0.9787 -0.2054 0.2054 0.9787 -2005.2675 371.9818)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000123412721730175390800000009363682506244899768_)"
    },
    d: "M2669.246,2295.408 c0,0-6.169,15.33-20.796,12.977c-13.098-2.106-12.431-38.944-3.533-45.216c2.967-2.091,8.989-2.887,13.458-1.058 c3.143,1.285,12.498,9.852,10.413,22.401c2.886-1.717,5.761-1.448,6.758,0.096c1.266,1.956-0.785,5.507-1.249,6.311 C2672.687,2293.707,2670.343,2294.931,2669.246,2295.408z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093158797143652159050000003492263407198663575_",
    gradientUnits: "userSpaceOnUse",
    x1: 2849.2986,
    y1: 2938.9045,
    x2: 2960.6167,
    y2: 3027.2524,
    gradientTransform: "matrix(0.8755 0.4833 -0.4833 0.8755 1595.3511 -1698.9034)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000093158797143652159050000003492263407198663575_)"
    },
    d: "M2634.544,2254.245 c0,0,40.756,2.97,60.494,7.879c3.497,0.87,6.977-1.507,7.389-5.087c1.244-10.824,0.078-30.958-24.526-35.358 C2646.809,2216.119,2636.232,2235.962,2634.544,2254.245z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000110443041472059376240000008165512761424202906_",
    gradientUnits: "userSpaceOnUse",
    x1: 2833.7854,
    y1: 2979.4302,
    x2: 2837.7888,
    y2: 2957.6331,
    gradientTransform: "matrix(0.8755 0.4833 -0.4833 0.8755 1595.3511 -1698.9034)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000110443041472059376240000008165512761424202906_)"
    },
    d: "M2636.52,2250.667 c0,0-14.39,1.711-13.343,5.338c1.047,3.627,61.757,4.044,61.757,4.044L2636.52,2250.667z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000105419914359853909810000003342671846099467442_",
    gradientUnits: "userSpaceOnUse",
    x1: 2818.3735,
    y1: 2913.9016,
    x2: 2875.3145,
    y2: 2981.519,
    gradientTransform: "matrix(0.8755 0.4833 -0.4833 0.8755 1595.3511 -1698.9034)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000105419914359853909810000003342671846099467442_)"
    },
    d: "M2672.432,2231.587 c0.737-4.315,4.63-7.136,9.462-8.985c-1.263-0.352-2.58-0.67-3.993-0.922c-27.537-4.925-38.976,10.077-42.405,26.274 c6.978,0.587,14.746,1.316,18.989,1.966C2663.387,2251.283,2670.244,2244.385,2672.432,2231.587z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M967.553,826.109c0,0,68.075-131.893,184.776-80.748 c116.701,51.145,105.895,24.301,186.937,34.481c81.042,10.18,181.337,66.417,116.062,77.739 c-65.275,11.322-576.381,24.289-576.381,24.289S886.511,833.019,967.553,826.109z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstructionLoan);
export default __webpack_public_path__ + "static/media/construction-loan.3dee910524496edf82c434d0e3867e2c.svg";
export { ForwardRef as ReactComponent };